import React from 'react'
import { Form, Checkbox, DatePicker, Input, Select, Divider } from 'antd'
import { Message } from 'semantic-ui-react';

class CaseDocumentsForm extends React.Component {
  render() {
    return (
      <Form name="case-documents">
        <div className="fluid-field checkbox-field">
          <Checkbox>Request Sent to Specialist</Checkbox>
        </div>
        <Form.Item 
          label={
            <React.Fragment>
              PIC 2
              <button className="field-actions">
                Recent Changes
              </button>
            </React.Fragment>
          }
        >
          <Select size="large" value="1">
            <Select.Option value="1">Staff</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item label="Paperwork Received Date">
          <DatePicker size="large" />
        </Form.Item>
        <Form.Item label="Attach Letter of Instruction (LOI)" className="fluid-field">
          <Message className="upload-box">
            <div className="upload-file">
              <input type="file" /> Click here to upload
            </div>
          </Message>
        </Form.Item>
        <Form.Item label="Or Share Download Link" className="fluid-field">
          <Input.TextArea rows={6} />
        </Form.Item>
        <Form.Item label="Attach Original Reports" className="fluid-field">
          <Message className="upload-box">
            <div className="upload-file">
              <input type="file" /> Click here to upload
            </div>
          </Message>
        </Form.Item>
        <Form.Item label="Or Share Download Link" className="fluid-field">
          <Input.TextArea rows={6} />
        </Form.Item>
        <Form.Item label="Special Request" className="fluid-field">
          <Checkbox.Group>
            <Checkbox>Urgent Report</Checkbox>
            <Checkbox> 20 pages</Checkbox>
          </Checkbox.Group>
        </Form.Item>
        <Form.Item label="Comments" className="fluid-field">
          <Input.TextArea rows={6} />
        </Form.Item>

        <Divider className="fluid-field" />
        <div className="fluid-field checkbox-field">
          <Checkbox>Email Paperwork to Doctor</Checkbox>
          <button className="field-actions">
            Resend Paperwork
          </button>
        </div>
        <div className="fluid-field checkbox-field">
          <Checkbox>Disable Report Reminders</Checkbox>
        </div>
        <Form.Item label="Send Paperwork by Other Methods">
          <Checkbox.Group>
            <Checkbox>Fax</Checkbox>
            <Checkbox>Express Post</Checkbox>
            <Checkbox>In House</Checkbox>
            <Checkbox>Standard Post</Checkbox>
          </Checkbox.Group>
        </Form.Item>
        <Form.Item label="Other Method Sending Date">
          <DatePicker size="large" />
        </Form.Item>

        <Divider className="fluid-field" />
        <div className="fluid-field checkbox-field">
          <Checkbox>Dictation Received</Checkbox>
        </div>
        <Form.Item 
          label={
            <React.Fragment>
              PIC 3
              <button className="field-actions">
                Recent Changes
              </button>
            </React.Fragment>
          }
        >
          <Select size="large" value="1">
            <Select.Option value="1">Staff</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item label="Dictation Received Date" required>
          <DatePicker size="large" />
        </Form.Item>
        <Form.Item label="Attached Dictations" className="fluid-field">
          <Message className="upload-box">
            <div className="upload-file">
              <input type="file" /> Click here to upload
            </div>
          </Message>
        </Form.Item>
        <Form.Item label="OneDrive links to Dictation Files" className="fluid-field">
          <Input.TextArea rows={6} />
        </Form.Item>
        <Form.Item label="Dictation Comments" className="fluid-field">
          <Input.TextArea rows={6} />
        </Form.Item>

        <Divider className="fluid-field" />
        <div className="fluid-field checkbox-field">
          <Checkbox>Dictation Sent To Typist</Checkbox>
        </div>
        <Form.Item label="Typist" required>
          <Select size="large" value="1">
            <Select.Option value="1">Staff</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item label="Attached Dictation Instruction" className="fluid-field">
          <Message className="upload-box">
            <div className="upload-file">
              <input type="file" /> Click here to upload
            </div>
          </Message>
        </Form.Item>
        <Form.Item label="Attached Report Samples" className="fluid-field">
          <Message className="upload-box">
            <div className="upload-file">
              <input type="file" /> Click here to upload
            </div>
          </Message>
        </Form.Item>
        <Form.Item label="Attached Report Templates" className="fluid-field">
          <Message className="upload-box">
            <div className="upload-file">
              <input type="file" /> Click here to upload
            </div>
          </Message>
        </Form.Item>
        <div className="fluid-field checkbox-field">
          <Checkbox>Send Files to Typist</Checkbox>
          <button className="field-actions">
            Resend Dictation Files
          </button>
        </div>
        <Form.Item label="Attached Typed Report" className="fluid-field">
          <Message className="upload-box">
            <div className="upload-file">
              <input type="file" /> Click here to upload
            </div>
          </Message>
        </Form.Item>
        <Form.Item label="Typist's transcribing time (hours)">
          <Input size="large" />
        </Form.Item>
        <Form.Item label="Typist's submitting date">
          <DatePicker size="large" />
        </Form.Item>
        <Form.Item label="Approved by">
          <Select size="large" value="1">
            <Select.Option value="1">Staff</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item label="Approved on">
          <DatePicker size="large" />
        </Form.Item>

        <Divider className="fluid-field" />
        <div className="fluid-field checkbox-field">
          <Checkbox>Report Draft Sent to Specialist</Checkbox>
        </div>
        <Form.Item 
          label={
            <React.Fragment>
              PIC 4
              <button className="field-actions">
                Recent Changes
              </button>
            </React.Fragment>
          }
        >
          <Select size="large" value="1">
            <Select.Option value="1">Staff</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item label="Report Draft Received Date">
          <DatePicker size="large" />
        </Form.Item>
        <Form.Item label="Attached Report Draft" className="fluid-field">
          <Message className="upload-box">
            <div className="upload-file">
              <input type="file" /> Click here to upload
            </div>
          </Message>
        </Form.Item>
        <Form.Item label="Report Draft Sent Date" required>
          <DatePicker size="large" />
        </Form.Item>
        <div className="fluid-field checkbox-field">
          <Checkbox>Send Notice To</Checkbox>
          <button className="field-actions">
            To Business Email ()
          </button>
        </div>
        <div className="fluid-field checkbox-field">
          <Checkbox>Send Report Draft as Attachment</Checkbox>
        </div>
        <Form.Item label="Comments" className="fluid-field">
          <Input.TextArea rows={6} />
        </Form.Item>

        <Divider className="fluid-field" />
        <div className="fluid-field checkbox-field">
          <Checkbox>Corrected Report Returned from Specialist</Checkbox>
        </div>
        <Form.Item 
          label={
            <React.Fragment>
              PIC 3
              <button className="field-actions">
                Recent Changes
              </button>
            </React.Fragment>
          }
        >
          <Select size="large" value="1">
            <Select.Option value="1">Staff</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item label="Report Returned Date">
          <DatePicker size="large" />
        </Form.Item>
        <Form.Item label="Attach Report Returned from Doctor" className="fluid-field">
          <Message className="upload-box">
            <div className="upload-file">
              <input type="file" /> Click here to upload
            </div>
          </Message>
        </Form.Item>

        <Divider className="fluid-field" />
        <div className="fluid-field checkbox-field">
          <Checkbox>Report Sent to CMs</Checkbox>
        </div>
        <Form.Item 
          label={
            <React.Fragment>
              PIC 5
              <button className="field-actions">
                Recent Changes
              </button>
            </React.Fragment>
          }
        >
          <Select size="large" value="1">
            <Select.Option value="1">Staff</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item label="Date of Report Sent to CMs">
          <DatePicker size="large" />
        </Form.Item>
        <Form.Item label="Attach Final Report" className="fluid-field">
          <Message className="upload-box">
            <div className="upload-file">
              <input type="file" /> Click here to upload
            </div>
          </Message>
        </Form.Item>
        <Form.Item label="Send Final Report to" className="fluid-field">
          <Input.TextArea rows={4} />
        </Form.Item>
        <div className="fluid-field checkbox-field">
          <Checkbox>Booking Solicitor</Checkbox>
          <button className="field-actions">
            Resend Reports
          </button>
        </div>
        <div className="fluid-field checkbox-field">
          <Checkbox>Booking CMs</Checkbox>
          <button className="field-actions">
            Resend Reports
          </button>
        </div>
        <Form.Item label="Attach Amended Reports" className="fluid-field">
          <Message className="upload-box">
            <div className="upload-file">
              <input type="file" /> Click here to upload
            </div>
          </Message>
        </Form.Item>
        <Form.Item label="Send Amended Reports to" className="fluid-field">
          <Input.TextArea rows={4} />
        </Form.Item>
        <div className="fluid-field checkbox-field">
          <Checkbox>Booking Solicitor</Checkbox>
          <button className="field-actions">
            Resend Amended Reports
          </button>
        </div>
        <div className="fluid-field checkbox-field">
          <Checkbox>Booking CMs</Checkbox>
          <button className="field-actions">
            Resend Amended Reports
          </button>
        </div>
        <Form.Item label="Comments" className="fluid-field">
          <Input.TextArea rows={6} />
        </Form.Item>
      </Form>
    ) 
  }
}

export default CaseDocumentsForm